module.exports = __webpack_public_path__ + "img/sc.bd147d70.jpg";